import type { ReactNode } from 'react';
import { cx } from '../utils/cx.js';
import styles from './RowActionPill.module.css';

/**
 * Class names for the pill's inner controls, so apps style row actions from one place.
 * `wrap` goes on the click-stop span around the pill.
 */
export const rowActionPillClasses = {
  wrap: styles.wrap,
  primaryBtn: styles.primaryBtn,
  menuBtn: styles.menuBtn,
  iconWrap: styles.iconWrap,
  menuItemLabel: styles.menuItemLabel,
  menuMin200: styles.menuMin200,
  menuMin220: styles.menuMin220,
} as const;

export type RowActionPillProps = {
  primary: ReactNode;
  menu?: ReactNode;
  disabled?: boolean;
  /** Let tooltips/popovers escape the pill (drops the clipping `overflow: hidden`). */
  allowOverflow?: boolean;
  className?: string;
};

/** Shared pill shell for table row actions (primary button + optional ⋮ menu). */
export function RowActionPill({ primary, menu, disabled, allowOverflow, className }: RowActionPillProps) {
  return (
    <span
      className={cx(
        styles.shell,
        disabled && styles.shellDisabled,
        allowOverflow && styles.shellOverflowVisible,
        className,
      )}
      data-wp-row-action-pill
    >
      <span className={styles.primarySlot}>{primary}</span>
      {menu ? (
        <>
          <span className={styles.separator} aria-hidden />
          <span className={styles.menuSlot}>{menu}</span>
        </>
      ) : null}
    </span>
  );
}
